
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheLinkText extends Vue {
  @Prop() link!: any;
}
